"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SvgIcon_1 = require("./internal/SvgIcon");

exports.DocumentLite = function (props) {
  return react_1.default.createElement(SvgIcon_1.SvgIcon, tslib_1.__assign({}, props), react_1.default.createElement("svg", {
    viewBox: "0 0 16 16"
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M10.0029 9.99902H4.99902V9.00098H10.0029V9.99902ZM10.0029 8.00293H4.99902V6.99805H10.0029V8.00293ZM8.99805 6H4.99902V5.00195H8.99805V6ZM4.00098 2.99902V12.002H11.001V6L8 2.99902H4.00098ZM4.00098 13C3.70019 13 3.45866 12.9089 3.27637 12.7266C3.09407 12.5443 3.00293 12.3027 3.00293 12.002V2.99902C3.00293 2.69824 3.09407 2.45671 3.27637 2.27441C3.45866 2.09212 3.70019 2.00098 4.00098 2.00098H8.41699L11.999 5.58301V12.002C11.999 12.2845 11.8988 12.5215 11.6982 12.7129C11.4977 12.9043 11.2653 13 11.001 13H4.00098Z",
    clipRule: "evenodd"
  })));
};